export const validateRedirectUrl = (
  url: string | null | undefined
): url is string => {
  if (!url || typeof url !== "string") return false;
  let decoded: string;
  try {
    decoded = decodeURIComponent(url);
  } catch {
    return false;
  }
  const trimmed = decoded.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) return false;
  return true;
};

export const sanitizeRedirectUrl = (url: string | null | undefined): string => {
  return validateRedirectUrl(url) ? url : "/";
};

export const sanitizeSearchParams = (search: string): string => {
  if (!search) return "";
  const params = new URLSearchParams(search);
  const sanitized = new URLSearchParams();
  params.forEach((value, key) => {
    let decodedValue: string;
    try {
      decodedValue = decodeURIComponent(value);
    } catch {
      return;
    }
    const trimmed = decodedValue.trim();
    if (trimmed.startsWith("//") || /^[a-z]+:/i.test(trimmed)) return;
    sanitized.set(key, value);
  });
  const result = sanitized.toString();
  return result ? `?${result}` : "";
};

const IDENTIFIER_REGEX = /^[A-Za-z0-9_.-]+$/;

export const isValidIdentifier = (
  value: string | null | undefined
): boolean => {
  if (!value || typeof value !== "string") return false;
  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed.length > 128) return false;
  return IDENTIFIER_REGEX.test(trimmed);
};

const TOKEN_REGEX = /^[a-zA-Z0-9_\-.]+$/;

export const isValidToken = (value: string | null | undefined): boolean => {
  if (!value || typeof value !== "string") return false;
  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed.length > 1024) return false;
  return TOKEN_REGEX.test(trimmed);
};
